import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import {
  useNavigate,
} from "react-router-dom";
import Logo from './assets/Logo-Dermatopic.png'
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';

function Header(props) {
  // const { sections, title } = props;
  const pages = [
    { title: 'Escalas', url: '#' },
    { title: 'Créditos', url: '#/creditos' },
    // { title: 'Lenguaje', url: '#' },
  ];
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <React.Fragment>
      <Toolbar sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: 'RGB(87,51,132)' }}>
          <img onClick={() => navigate('/')} src={Logo} style={{ maxWidth: 200, marginRight: 20, cursor:'pointer'}}/>
          <Box sx={{ flexGrow: 1,justifyContent: 'flex-end', display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={()=>navigate('/' + page.url)}>
                  <Typography textAlign="center">{page.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, justifyContent: 'flex-end', display: { xs: 'none', md: 'flex' } }}>
          {pages.map((section) => (
            <Link
              color="inherit"
              noWrap
              key={section.title}
              variant="body2"
              href={section.url}
              sx={{ pt: 0, pl:1, pr:1, flexShrink: 0, color: 'white', textDecoration: 'none' }}
            >
              {section.title}
            </Link>
          ))}
            {/*pages.map((page) => (
              <Button
                className="MenuItem"
                key={page}
                onClick={()=>navigate('/categoria/' + page.url)}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page.title}
              </Button>
            ))*/}
          </Box>
          {/*<Button sx={{color: 'white', borderColor: 'white', borderRadius: 8, textTransform: 'capitalize'}} variant="outlined" size="small">
            Ingresar
          </Button>*/}
      </Toolbar>
    </React.Fragment>
  );
}

export default Header;